import { format } from 'date-fns';

export const getFormattedDate = (date: Date, formatString = 'MM/dd/yyyy') => format(date, formatString);
